<div class="container" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
  <div fxLayout="column" fxLayoutAlign="center center" class="icon-container">
    <mat-icon>done</mat-icon>
  </div>
  <h2 class="fs-18px mb-20">{{ 'keywords.authentication_successful' | translate }}!</h2>
  <button class="medium-button-blue w-100" mat-button (click)="close()">Ok</button>
</div>
